export default {
    modals: {
        attachments: {
            show: false,
            title: '',
            file: null,
            from_finder: false
        }
    },
    document_files_new: [],
    document_files_delete: [],
    params: {
        document_id: null,
        files: []
    },
    loading: {
        loading_files: false
    }
}


// WEBPACK FOOTER //
// ./src/modules/modal-attachments/state.js